module.exports = __webpack_public_path__ + "static/media/cola_logo.d299faa5.png";